module.exports = {"archive":"Archiv","archives":"Archive","archive_customer":"archivierte Prüfobjekte des Kunden :customer","to_archive":"zum Archiv","archive_appointment":"Prüfobjekt archivieren"};


//////////////////
// WEBPACK FOOTER
// ./resources/lang/de/archive.php
// module id = cOhe
// module chunks = 1